export default "__VITE_ASSET__d6b53143__"